import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

import { AdminLegendVariant } from '@pharmaplan/common';
import styles from './styles';
import strings from '../../../../localization';
import useAdminLegendNavigation from '../../../../hooks/AdminLegend/useAdminLegendNavigation';

interface IAdminLegend {
  variant: `${AdminLegendVariant}`;
  totalHrs: number;
  totalCount: number;
  isRow: boolean;
  customClass?: Record<string, unknown>;
}

const AdminLegend = ({
  variant,
  totalHrs,
  totalCount,
  isRow,
  customClass,
}: IAdminLegend) => {
  const isTotalVariant = variant === AdminLegendVariant.total;
  const { handleNavigateToReport } = useAdminLegendNavigation();

  const onClick = () => {
    handleNavigateToReport(variant, null);
  };

  return (
    <Grid
      wrap="nowrap"
      variant="text"
      component={Button}
      disabled={isTotalVariant}
      onClick={onClick}
      container
      sx={[
        styles.legendContainerBg(variant),
        isTotalVariant ? {} : styles.container(variant),
        customClass as SystemStyleObject,
      ]}
    >
      <Grid
        sx={[styles.startContainer, styles.columnContainer]}
        item
        xs={12}
        md={12}
      >
        <Box sx={styles.startContainer} component="div">
          <Typography
            noWrap
            sx={[styles.legendTitle, isRow && styles.rowLegendText]}
          >
            {strings[variant]}
          </Typography>
        </Box>
        <Box
          component="div"
          sx={[
            styles.legendTotalHrs,
            isRow && styles.rowLegendText,
            styles.totalHrsCountColor(variant),
            styles.startContainer,
          ]}
        >
          {strings.formatString(strings.hoursWorked, Math.trunc(totalHrs))}
        </Box>
      </Grid>
      <Grid item xs={10} md={2} sx={styles.totalCountContainer}>
        <Box
          sx={[
            styles.legendTotalCount,
            isRow && styles.rowLegendTotalCount,
            styles.totalHrsCountColor(variant),
          ]}
          component="div"
        >
          {totalCount}
        </Box>
      </Grid>
    </Grid>
  );
};
export default AdminLegend;
